<template>
  <div v-if="!isCourierEnrollment" class="col-xs-6 courier">
    <div class="col-lg-6 col-md-12 end-md courier-img-wrapper">
      <picture>
        <source srcset="/assets/Description/couriers.webp" type="image/webp">
        <img
          class="block-add-partner-img"
          src="/assets/Description/couriers.svg"
          loading="lazy"
          alt="about-us-icon"
          width="214"
          height="164"
        >
      </picture>
    </div>
    <div class="col-lg-6 col-md-12 courier-content">
      <h4 class="become-courier-title">{{ $t('Become a courier') }}</h4>
      <p class="become-courier-message">{{ $t('Join a dynamic team of couriers') }}</p>
      <router-link class="become-courier" :to="locationRoute('/about-courier')">{{ $t('Become a courier') }}</router-link>
    </div>
    <register v-if="show"/>
  </div>
</template>

<script async>
import { mapGetters } from 'vuex'
import { locationRoute } from '@vue-storefront/core/scripts/utils/navigation';

const Register = () => import(/* webpackChunkName: "vsf-courier-register" */ '../Static/Register');

export default {
  name: 'AddCouriers',
  methods: { locationRoute },
  mounted () {
    if (this.$route.params.hasOwnProperty('become_courier')) this.showModal()
  },
  computed: {
    ...mapGetters({
      courierEnrollment: 'configs/getConfigCourierEnrollment'
    }),

    isCourierEnrollment () {
      let isPresent = this.courierEnrollment.find(meta => meta.key === 'disable_courier_enrollment')
      return isPresent ? !!isPresent.value : false
    }
  },
  data () {
    return {
      show: false
    }
  },
  components: {
    Register
  }
}
</script>

<style lang="scss" scoped>
  .become-courier {
    padding: 10px 30px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    background: #F2994A;
    border-radius: 10px;
    min-width: 175px;
    max-width: 230px;
    border: none;
    white-space: nowrap;

    &:hover {
      background: #F2994A
    }
    &-title {
      font-size: 25px;
      margin-top: 0;
      margin-bottom: 10px;
    }
    &-message {
      margin: 0;
      font-size: 16px;
      margin-bottom: 20px;
    }

    @media (max-width: 991px) {
      &-message {
        flex: 1 1 auto;
      }
    }
  }
  .courier {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 10px;

    &-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1 1 auto;
    }

    &-img-wrapper {
      flex: 0 0 auto;
    }

    &-img {
      width: 100%;
      height: 164px;
    }

    @media only screen and (max-width: 991px) {
      flex-direction: column;

      &-content {
        height: auto;
      }

      &-img {
        height: 180px;
      }
    }

    @media only screen and (max-width: 576px) {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
  .block-add-partner-img {
    object-fit: contain;
  }
</style>
